<template>
  <div class="bb-notifications-window-project">
    <i
      class="icon-cross bb-notifications-window-project__icon"
      @click.stop="onDelete"
    />
    <div v-html="BellIcon()"/>
    <div class="bb-notifications-window-project-right">
      <div class="bb-notifications-window-project__title">
        Reminder
      </div>
      <div class="bb-notifications-window-project__description">
        {{projectName}}
      </div>
      <div class="bb-notifications-window-project__description">
        {{item.comment}}
      </div>
    </div>
  </div>
</template>

<script>
import { BellIcon } from '@/constants/icon'

export default {
  name: 'NotificationsWindowReminder',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    BellIcon
  }),
  computed: {
    projectName () {
      const { project = [], request = [] } = this.item
      const [projectData = {}] = project
      const [requestData = {}] = request
      return projectData.name || requestData.name
    }
  },
  methods: {
    onDelete () {
      this.$emit('onDelete', this.index)
    }
  }
}
</script>

  <style lang="scss" scoped>
  @import "../../../sass/variables";

    .bb-notifications-window-project {
      display: grid;
      grid-template-columns: 36px 1fr;
      grid-gap: 0 16px;
      width: 292px;
      min-height: 79px;
      padding: 16px 18px 16px 18px;
      border-radius: 4px;
      background: $color-white;
      box-shadow: 0 0 20px rgba($color-black, 0.07);
      position: relative;

      &__icon {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 24px;
        font-size: 12px;
        color: $color-silver-deep;
        cursor: pointer;
        transition: 0.3s;

        &:before {
          margin: 0;
        }

        &:hover {
          color: $color-dusty-gray
        }
      }

      &__title {
        font-size: 13px;
        font-weight: 500;
        line-height: 16px;

        &_capitalize {
          text-transform: capitalize;
        }
      }

      &__description {
        font-size: 11px;
        font-weight: 300;
        line-height: 13px;

        &:first-letter {
          text-transform: capitalize;
        }

        &_bold {
          font-weight: 500;
        }
      }
    }

    .bb-notifications-window-project-right {
      display: grid;
      grid-gap: 7px 0;
    }
  </style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsWindow/NotificationsWindowReminder.vue